import { render, staticRenderFns } from "./ProfileAddress.vue?vue&type=template&id=451a3d78&"
import script from "./ProfileAddress.vue?vue&type=script&lang=js&"
export * from "./ProfileAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports